__turbopack_context__.v({
  "figure": "DIcuxa_figure",
});
